"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexRatesComponent = void 0;
require("./components/flexLoader/FlexLoader");
require("./components/flexSelectorComponent/FlexSelectorComponent");
const dates = __importStar(require("./helpers/dates"));
const chart_js_1 = require("chart.js");
const responses_1 = require("./helpers/responses");
const enums_1 = require("./helpers/enums");
const lit_element_1 = require("lit-element");
const js_1 = require("@mdi/js");
const tooltip_1 = require("./helpers/tooltip");
const Fetch_1 = require("./helpers/Fetch");
const style_1 = __importDefault(require("./style"));
const SVGHelpers_1 = require("./helpers/SVGHelpers");
const ticks_1 = require("./helpers/ticks");
const BAR_DATA = 0;
const LINE_DATA = 1;
const LegendaInfo = lit_element_1.html `In de grafiek zie je de actuele en historische
    inkooptarieven voor stroom (in kWh) en gas (in m<sup>3</sup>). Dit zijn de
    werkelijke kostprijzen op de groothandelsmarkt. Deze hanteren wij voor het
    afrekenen van de energie die je verbruikt. Let op: de tarieven in de grafiek
    zijn exclusief inkoopkosten, energiebelasting, Opslag Duurzame Energie en de
    regiotoeslag voor gas. Deze opslagen zijn immers verplicht en wisselen
    maximaal &eacute;&eacute;n keer per jaar.<br />
    <br />
    - Het tarief van <b>elektriciteit</b> wisselt ieder uur<br />
    - Het tarief voor <b>gas</b> wisselt iedere dag om 06:00 uur en is
    vervolgens voor de komende 24 uur hetzelfde<br />
    - Elke dag om 15:00 uur zijn de <b>tarieven voor morgen bekend</b><br />
    <br />
    In de grafiek zijn dus de tarieven voor de volgende dag te zien. Ook vind je
    er wat de tarieven in het verleden waren. Dit kun je per dag, week, maand of
    jaar bekijken. Dan zie je ook het gemiddelde tarief. Dit is het gemiddelde
    tarief voor de periode die je hebt geselecteerd. Als je bijvoorbeeld een dag
    selecteert, dan zie je het gemiddelde van 24 uur.`;
let FlexRatesComponent = class FlexRatesComponent extends lit_element_1.LitElement {
    constructor() {
        super(...arguments);
        this.counter = 5;
        // legenda properties
        this.legendaTitle = lit_element_1.html `Begrippen en uitleg`;
        // bar properties
        this.barColor = '#3a7ddb';
        this.barHoverColor = '#265393';
        this.lineColor = '#3a7cdb80';
        this.axisLabelColor = '#8c99ab';
        this.dataProviderUrl = 'https://epexspot.com';
        this.legendaInformation = LegendaInfo;
        this.errorMessage = lit_element_1.html `Het ophalen van de
    flextarieven is op dit moment niet mogelijk.`;
        // private properties
        this.firstSelector = ['Stroom', 'Gas'];
        this.secondSelector = ['Dag', 'Week', 'Maand', 'Jaar'];
        this.thirdSelector = ['incl. BTW', 'excl. BTW'];
        this.barChartDescription = 'Uurtarief';
        this.chartAverageDescription = 'Gemiddeld uurtarief';
        this.flexDatasets = [{}, {}];
        this.currentDate = new Date();
        this.busy = false;
        this.legenda = false;
        this.error = false;
        this.barDates = [];
        this.firstTime = true;
        this.tickOptions = { min: 0, max: 0.1, tick: 0.01 };
        this.shadowRootClickHandler = () => tooltip_1.hideToolTip(this.chartjsTooltip);
        this.chartContainerClickHandler = (e) => e.stopPropagation();
        this.render = () => lit_element_1.html `
        <header>
            <div id="header-information">
                <div @click="${this.toggleLegenda}" ?hidden=${this.legenda}>
                    ${SVGHelpers_1.svgMDRender(js_1.mdiInformationOutline)}
                </div>
                <div @click="${this.toggleLegenda}" ?hidden=${!this.legenda}>
                    ${SVGHelpers_1.svgMDRender(js_1.mdiClose)}
                </div>
            </div>
        </header>
        <main>
            ${this.renderMain(this.legenda)}
            <div id="chartjs-tooltip" class="center top hide-tooltip"></div>
        </main>
        <footer ?hidden="${this.legenda}">
            <flex-selector-component
                .icon=${SVGHelpers_1.svgMDRender(js_1.mdiHome)}
                .options="${this.firstSelector}"
                prefix="type"
                @option-changed="${this.selectorChanged}"
            ></flex-selector-component>
            <flex-selector-component
                .icon=${SVGHelpers_1.svgMDRender(js_1.mdiCalendar)}
                .options="${this.secondSelector}"
                prefix="date"
                @option-changed="${this.selectorChanged}"
            ></flex-selector-component>
            <flex-selector-component
                id="vat-selector"
                .icon=${SVGHelpers_1.svgMDRender(js_1.mdiCurrencyEur)}
                .options="${this.thirdSelector}"
                prefix="btw"
                @option-changed="${this.selectorChanged}"
            ></flex-selector-component>
        </footer>
        <p class="disclaimer">
            Aan alle getoonde energietarieven kunnen geen rechten worden
            ontleend. Wij halen de tarieven op van
            <a href="${this.dataProviderUrl}" target="_blank">
                ${this.dataProviderUrl.replace(/^https?:\/\//, '')}.
            </a>
        </p>
    `;
        // Create our number formatter.
        this.formatter = new Intl.NumberFormat('nl-NL', {
            style: 'currency',
            currency: 'EUR',
        });
        this.renderChartData = (labels) => {
            if (this.chartCanvasElement == null) {
                return;
            }
            if (this.chart) {
                this.chart.destroy();
            }
            const ctx = this.chartCanvasElement.getContext('2d');
            if (ctx) {
                const that = this;
                this.chart = new chart_js_1.Chart(ctx, {
                    type: 'bar',
                    data: {
                        labels: labels,
                        datasets: this.flexDatasets,
                    },
                    options: {
                        legend: {
                            display: false,
                        },
                        responsive: true,
                        maintainAspectRatio: false,
                        tooltips: {
                            intersect: false,
                            mode: 'index',
                            axis: 'x',
                            enabled: false,
                            /**
                             * Custom function called for every model in graph when click event occurs on graph
                             * @param {Object} tooltipModel
                             */
                            custom: (tooltipModel) => {
                                const toolT = Object.assign({}, tooltipModel);
                                if (toolT && toolT.body) {
                                    toolT.body.forEach(body => {
                                        if (body && body.lines[0]) {
                                            const arr = body.lines[0].split(':');
                                            const val = Number(arr[1]).toFixed(5);
                                            body.lines[0] = `${that.formatter.format(Number(val))}`;
                                            const vat = that.vatSelector;
                                            if (vat) {
                                                body.lines[0] =
                                                    body.lines[0] +
                                                        ' ' +
                                                        vat.options[vat.previousSelectedOption];
                                            }
                                        }
                                    });
                                    if (Array.isArray(toolT.title)) {
                                        const currentPrice = toolT.dataPoints[0].index;
                                        if (currentPrice == null) {
                                            console.warn('missing currentPrice');
                                            return;
                                        }
                                        else if (this.barDates.length === 0 ||
                                            this.barDates[currentPrice] == null) {
                                            return;
                                        }
                                        const dt = new Date(this.barDates[currentPrice]);
                                        toolT.title[0] = dates.formatTooltipTitle(dt, Fetch_1.energyPrices.interval, toolT.title[0]);
                                    }
                                }
                                if (that.chart && that.chartCanvasElement) {
                                    tooltip_1.customToolTip(toolT, that.chart, that.chartCanvasElement, false, that.chartjsTooltip, this.getBoundingClientRect());
                                }
                                else if (that.chart &&
                                    that.chart.options.tooltips) {
                                    that.chart.options.tooltips.enabled = true;
                                }
                            },
                        },
                        scales: {
                            yAxes: [
                                {
                                    ticks: {
                                        stepSize: this.tickOptions.tick,
                                        min: this.tickOptions.min,
                                        max: this.tickOptions.max,
                                        // Include a dollar sign in the ticks
                                        callback: (value) => {
                                            if (Number(value) < 10) {
                                                value = Number(value).toFixed(2);
                                            }
                                            return new Intl.NumberFormat('nl-NL', {
                                                style: 'currency',
                                                currency: 'EUR',
                                            }).format(Number(value));
                                        },
                                        fontColor: that.axisLabelColor,
                                    },
                                    gridLines: {
                                        drawBorder: false,
                                    },
                                },
                            ],
                            xAxes: [
                                {
                                    ticks: {
                                        fontColor: that.axisLabelColor,
                                    },
                                    scaleLabel: {
                                        display: false,
                                    },
                                    gridLines: {
                                        display: false,
                                    },
                                },
                            ],
                        },
                    },
                });
            }
        };
        this.selectorChanged = (e) => {
            e.stopImmediatePropagation();
            const selectorInformation = e.detail;
            switch (selectorInformation.prefix) {
                case 'btw':
                    Fetch_1.energyPrices.setBtw(selectorInformation.option === 'incl. BTW');
                    break;
                case 'type':
                    let usageType = enums_1.UsageType.UsageTypeElectricity;
                    if (selectorInformation.option === 'Gas') {
                        usageType = enums_1.UsageType.UsageTypeGas;
                    }
                    Fetch_1.energyPrices.setUsageType(usageType);
                    break;
                case 'date':
                    let updateDates = false;
                    // Fix for switching the `Year` because the current date is the first of january.
                    if (Fetch_1.energyPrices.interval === 6 &&
                        selectorInformation.option !== 'Jaar') {
                        this.currentDate = new Date();
                        Fetch_1.energyPrices.fromDate = this.currentDate;
                        updateDates = !updateDates;
                    }
                    let interval = enums_1.IntervalType.IntervalTypeDaily;
                    switch (selectorInformation.option) {
                        case 'Week':
                            interval = enums_1.IntervalType.IntervalTypeWeekly;
                            break;
                        case 'Maand':
                            interval = enums_1.IntervalType.IntervalTypeMonthly;
                            break;
                        case 'Jaar':
                            interval = enums_1.IntervalType.IntervalTypeYearly;
                            break;
                    }
                    Fetch_1.energyPrices.setInterval(interval);
                    if (updateDates) {
                        // needs to update after the interval has been set.
                        Fetch_1.energyPrices.setDates();
                    }
                    break;
            }
            this.fetchData();
        };
        this.renderMain = (_) => {
            const arrow = SVGHelpers_1.svgMDRender(js_1.mdiArrowRight);
            const currentDate = dates.format(Fetch_1.energyPrices.fromDate, Fetch_1.energyPrices.interval);
            return lit_element_1.html `
            ${this.renderShowLegenda()}
            <div class="main-content">
                <header ?hidden=${this.legenda}>
                    <div
                        class="arrow-container left"
                        @click=${() => {
                Fetch_1.energyPrices.prev();
                this.fetchData();
            }}
                    >
                        ${arrow}
                    </div>
                    <p class="date">${currentDate}</p>
                    <div
                        class="arrow-container"
                        @click=${() => {
                Fetch_1.energyPrices.next();
                this.fetchData();
            }}
                    >
                        ${arrow}
                    </div>
                </header>
                <header id="main-legenda-header" ?hidden=${this.legenda}>
                    <h3>Legenda</h3>
                    <p>
                        <span class="circle"></span>${this.barChartDescription}
                    </p>
                    <p>
                        <span class="dashes"></span>
                        <span class="dashes"></span>${this
                .chartAverageDescription}
                    </p>
                </header>
                <div
                    id="chart-container"
                    @click=${this.chartContainerClickHandler}
                    ?hidden=${this.legenda}
                >
                    <flex-loader ?loading="${this.busy}"></flex-loader>
                    ${this.error
                ? lit_element_1.html `<p class="error-message">
                              ${this.errorMessage}
                          </p>`
                : lit_element_1.html `
                              <canvas
                                  id="chart"
                                  width="100%"
                                  height="390"
                              ></canvas>
                          `}
                </div>
            </div>
        `;
        };
        this.renderShowLegenda = () => lit_element_1.html `
        <div id="main-legenda">
            <div id="legenda">
                <h1>${this.legendaTitle}</h1>
                <p>${this.legendaInformation}</p>
            </div>
        </div>
    `;
        this.formatRawData = (data) => {
            const rawData = new responses_1.RawData(data, Fetch_1.energyPrices.interval, Fetch_1.energyPrices.fromDate, Fetch_1.energyPrices.tillDate);
            this.barDates = rawData.rawdata.Prices.map(p => p.readingDate);
            const labels = rawData.getLabels();
            const dataSet = rawData.getDataSet(labels);
            const avgData = [];
            dataSet.forEach(() => avgData.push(data.average));
            this.flexDatasets[LINE_DATA] = {
                type: 'line',
                label: 'gemiddelde',
                data: avgData,
                fill: false,
                borderColor: this.lineColor,
                borderDash: [5],
                pointRadius: 0,
                order: 1,
            };
            this.flexDatasets[BAR_DATA] = {
                label: 'Flex tarieven',
                data: dataSet,
                backgroundColor: this.barColor,
                hoverBackgroundColor: this.barHoverColor,
                borderWidth: 1,
                order: 2,
            };
            const copiedData = [...dataSet];
            this.tickOptions = new ticks_1.Ticks(copiedData).GetOptions();
            return labels;
        };
        this.toggleLegenda = () => {
            this.legenda = !this.legenda;
        };
    }
    static get styles() {
        return [style_1.default];
    }
    connectedCallback() {
        super.connectedCallback();
        this.fetchData();
        this.addEventListener('click', this.shadowRootClickHandler);
    }
    disconnectedCallback() {
        this.firstTime = true;
        this.removeEventListener('click', this.shadowRootClickHandler);
        super.disconnectedCallback();
    }
    updated(changedProperties) {
        if ((changedProperties.has('barColor') && this.barColor != null) ||
            (changedProperties.has('barHoverColor') &&
                this.barHoverColor != null) ||
            (changedProperties.has('lineColor') && this.lineColor != null) ||
            (changedProperties.has('axisLabelColor') &&
                this.axisLabelColor != null)) {
            // prevent updating the first time the color is set and checks if the chart is rendered.
            if (this.firstTime || this.chart == null) {
                this.firstTime = false;
                return;
            }
            // rerender de data withe the correct colors and then the canvas (chart).
            this.renderChartData(this.formatRawData(Fetch_1.energyPrices.rawData));
        }
    }
    fetchData() {
        this.busy = true;
        Fetch_1.energyPrices
            .fetchPrices()
            .then(res => res.json())
            .then(data => {
            this.busy = false;
            return data;
        })
            .then(rawData => {
            Fetch_1.energyPrices.rawData = rawData;
            // FIXME https://energyzero.atlassian.net/browse/EN-2323
            Fetch_1.energyPrices.rawData.Prices = Fetch_1.energyPrices.rawData.Prices.filter((p) => p.readingDate >= Fetch_1.energyPrices.rawData.fromDate);
            this.renderChartData(this.formatRawData(Fetch_1.energyPrices.rawData));
        })
            .catch(e => {
            this.busy = false;
            console.error(e);
            this.error = true;
        });
    }
};
__decorate([
    lit_element_1.property({ type: Number })
], FlexRatesComponent.prototype, "counter", void 0);
__decorate([
    lit_element_1.property({ type: Object })
], FlexRatesComponent.prototype, "chart", void 0);
__decorate([
    lit_element_1.property({ type: String })
], FlexRatesComponent.prototype, "legendaTitle", void 0);
__decorate([
    lit_element_1.property({ attribute: 'bar-color', type: String, reflect: true })
], FlexRatesComponent.prototype, "barColor", void 0);
__decorate([
    lit_element_1.property({ attribute: 'bar-hover-color', type: String, reflect: true })
], FlexRatesComponent.prototype, "barHoverColor", void 0);
__decorate([
    lit_element_1.property({ attribute: 'line-color', type: String, reflect: true })
], FlexRatesComponent.prototype, "lineColor", void 0);
__decorate([
    lit_element_1.property({ attribute: 'axis-label-color', type: String, reflect: true })
], FlexRatesComponent.prototype, "axisLabelColor", void 0);
__decorate([
    lit_element_1.property({ attribute: 'data-provider-url', type: String, reflect: true })
], FlexRatesComponent.prototype, "dataProviderUrl", void 0);
__decorate([
    lit_element_1.property({ type: String })
], FlexRatesComponent.prototype, "legendaInformation", void 0);
__decorate([
    lit_element_1.property({ type: String })
], FlexRatesComponent.prototype, "errorMessage", void 0);
__decorate([
    lit_element_1.property({ type: Array })
], FlexRatesComponent.prototype, "firstSelector", void 0);
__decorate([
    lit_element_1.property({ type: Array })
], FlexRatesComponent.prototype, "secondSelector", void 0);
__decorate([
    lit_element_1.property({ type: Array })
], FlexRatesComponent.prototype, "thirdSelector", void 0);
__decorate([
    lit_element_1.property({ attribute: 'bar-chart-description', type: String })
], FlexRatesComponent.prototype, "barChartDescription", void 0);
__decorate([
    lit_element_1.property({ attribute: 'chart-average-description', type: String })
], FlexRatesComponent.prototype, "chartAverageDescription", void 0);
__decorate([
    lit_element_1.property({ type: Array })
], FlexRatesComponent.prototype, "flexDatasets", void 0);
__decorate([
    lit_element_1.property({ type: Object })
], FlexRatesComponent.prototype, "currentDate", void 0);
__decorate([
    lit_element_1.query('#chart')
], FlexRatesComponent.prototype, "chartCanvasElement", void 0);
__decorate([
    lit_element_1.query('#chartjs-tooltip')
], FlexRatesComponent.prototype, "chartjsTooltip", void 0);
__decorate([
    lit_element_1.query('#vat-selector')
], FlexRatesComponent.prototype, "vatSelector", void 0);
__decorate([
    lit_element_1.property({ type: Boolean })
], FlexRatesComponent.prototype, "busy", void 0);
__decorate([
    lit_element_1.property({ type: Boolean, reflect: true })
], FlexRatesComponent.prototype, "legenda", void 0);
__decorate([
    lit_element_1.property({ type: Boolean, reflect: true })
], FlexRatesComponent.prototype, "error", void 0);
__decorate([
    lit_element_1.property({ type: Array })
], FlexRatesComponent.prototype, "barDates", void 0);
__decorate([
    lit_element_1.property({ type: Boolean })
], FlexRatesComponent.prototype, "firstTime", void 0);
FlexRatesComponent = __decorate([
    lit_element_1.customElement('flex-rates-component')
], FlexRatesComponent);
exports.FlexRatesComponent = FlexRatesComponent;
